module.exports = __webpack_public_path__ + "img/10003bf3591a5b5c003a3f378643d35c.png";